export const footerLinks = [
  {
    id: 1,
    heading: "Categories",
    links: [
      "Laptops & Computers",
      "Cameras & Photography",
      "Smart Phones & Tablets",
      "Video Games & Consoles",
      "Waterproof Headphones",
    ],
  },
  {
    id: 2,
    heading: "Customer Care",
    links: ["My Account", "Discount", "Returns", "Orders History", "Order Tracking"],
  },
  {
    id: 3,

    heading: "Pages",
    links: [
      "Blog",
      "Browse the Shop",
      "Category",
      "Pre-Built Pages",
      "Visual Composer Elements",
      "WooCommerce Pages",
    ],
  },
];
